import { getDeterministicImage } from 'helpers/image-helper';
import HundredRating from 'molecules/hundred-rating';
import ImageWithFallback from 'atoms/image-with-fallback';
import PropTypes from 'prop-types';
import React from 'react';
import Recommendation from 'atoms/recommendation';
import Tooltip from 'atoms/tooltip';


export default function SnippetSimilar({ checkbox, className, domainCulture, estabFallbackImages, establishment, handleOnClick,
  numberFormat, position, searchGuests, t }) {

  const image = establishment.images ? establishment.images[0].small : establishment.img;
  const isInstantly = establishment.partners && establishment.partners[0] ? establishment.partners[0].instantly_booking : false;
  const isRecommended = establishment.recommendation;
  const showMaxGuests = establishment.maxGuests > 0 && establishment.maxGuests < 99;
  const showRooms = establishment.rooms > 0 && !(establishment.rooms > searchGuests);
  const hasDiscount = establishment.maxDayPrice && establishment.minDayPrice ? establishment.maxDayPrice !== establishment.minDayPrice : false;

  return (
    <div
      className={ `snippet-similar ${className} ${checkbox ? '-checked' : '-no-checked'}` }
      onClick={ (handleOnClick && handleOnClick.bind(this, establishment.id, position)) || null }
    >
      { checkbox ? <span className="snippet-similar__checkbox hundredicons-check" /> : null }
      <div className="snippet-similar__image-container">
        <ImageWithFallback
          className="snippet-similar__image"
          fallbackSrc={ getDeterministicImage(establishment.id, estabFallbackImages) }
          src={ image }
        />
        { isRecommended
          ? (
            <Recommendation
              className="snippet-similar__recomendation"
              position="bottom"
              text={ t('Recomended') }
              tooltipText={ t('This accommodation was visited by users with similar interests of yours') }
              tooltipX={ 435 }
              tooltipY={ 120 }
            />
          ) : null }
        { establishment.categoryLiteral
          ? (
            <div className="snippet-similar__type">
              { t(establishment.categoryLiteral) }
            </div>
          ) : null }
        {
          hasDiscount
            ? (
              <Tooltip
                key="snippet-similar__discount__tooltip"
                baseClassName="snippet-similar__discount__tooltip"
                position="bottom"
                title={ t("Highest price for this holiday rental when compared with other websites") }
                tooltipX={ -83 }
                tooltipY={ 75 }
              >
                <div
                  key="snippet-similar__discount"
                  className="snippet-similar__discount"
                >
                  <p className="snippet-similar__discount__text">
                    <b className={ `snippet-similar__discount__text__number -${domainCulture}` }>
                      { t('£{price}', { price: numberFormat(establishment.maxDayPrice) }) }
                    </b>
                  </p>
                  <p className="snippet-similar__discount__line-through" />
                </div>
              </Tooltip>
            )
            : null
        }
      </div>
      <div className="snippet-similar__footer">
        <div className="snippet-similar__footer__text">
          <div className="snippet-similar__footer__text-upper">
            <div className="snippet-similar__footer__text-upper__left">
              <div className="modal-map__container__upper-container__leftside__ammenities">
                { showMaxGuests
                  ? (
                    <span className="modal-map__container__upper-container__leftside__ammenities__capacity">
                      { establishment.maxGuests }
                      {' '}
                      { t('guests') }
                    </span>
                  ) : null
                }
                { showMaxGuests && showRooms
                  ? (
                    <span className="modal-map__container__upper-container__leftside__ammenities__dot">
                      { " · " }
                    </span>
                  ) : null
                }
                { showRooms
                  ? (
                    <span className="modal-map__container__upper-container__leftside__ammenities__rooms">
                      { establishment.rooms }
                      {' '}
                      { t('rooms') }
                    </span>
                  ) : null
                }
                { establishment.minDayPrice
                  && (
                    <div className={ `snippet-similar__footer__price ${isInstantly ? 'hundredicons-bolt-filled' : ''}` }>
                      { t("£{price}", { price: numberFormat(establishment.minDayPrice) }) }
                    </div>
                  )
                }
              </div>
              <div className="snippet-similar__footer__text-upper__left__rating">
                <HundredRating
                  adjective={ establishment.adjective }
                  adjectiveShown={ false }
                  combinedRating={ establishment.combinedRating }
                  isBlock={ false }
                  numberComments={ establishment.numberOfComments }
                  t={ t }
                  tooltipx={ 10 }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SnippetSimilar.defaultProps = {
  checkbox: null,
  className: '',
  domainCulture: '',
  numberFormat: n => n,
  searchGuests: 2,
};

SnippetSimilar.propTypes = {
  checkbox: PropTypes.bool,
  className: PropTypes.string,
  domainCulture: PropTypes.string,
  estabFallbackImages: PropTypes.arrayOf(PropTypes.string).isRequired,
  establishment: PropTypes.shape({
    discount: PropTypes.number,
    firstImage: PropTypes.string,
    id: PropTypes.number,
    instantBook: PropTypes.bool,
    maxGuests: PropTypes.number,
    minDayPrice: PropTypes.number,
    minTotalPrice: PropTypes.number,
    recommendation: PropTypes.number,
    rooms: PropTypes.number,
  }).isRequired,
  handleOnClick: PropTypes.func.isRequired,
  numberFormat: PropTypes.func,
  position: PropTypes.number.isRequired,
  searchGuests: PropTypes.number,
  t: PropTypes.func.isRequired,
};
